<template>
    <div>
        <h1>{{ $t('transactions.title') }}</h1>
        <div class="back">
            <router-link :to="{name: 'MarketPlace'}">
                <font-awesome-icon icon="chevron-left"/> {{$t('global.back')}}
            </router-link>
        </div>

        <b-table class="mt-4" striped hover :items="getItems()" :fields="getFields()"></b-table>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import formatDate from '../../filters/formatDate';

export default {
    computed: mapGetters('offer/list', [
        'transactionList'
    ]),
    methods: {
        getFields () {
            return [
                {
                    key: 'createdAt',
                    label: this.$t('transactions.createdAt')
                },
                {
                    key: 'questionNumber',
                    label: this.$t('transactions.questionNumber')
                },
                {
                    key: 'price',
                    label: this.$t('transactions.price')
                },
            ]
        },
        getItems() {
            return this.transactionList.map(function (item) {
                return {
                    createdAt: formatDate(item.createdAt),
                    questionNumber: item.questionNumber,
                    price: item.price,
                };
            });
        }
    },
    mounted() {
        this.$store.dispatch('offer/list/getTransactionList');
    }
}
</script>



// WEBPACK FOOTER //
// src/components/marketplace/Transactions.vue